@if (description()) {
    <span class="ap-checkbox__description" data-testid="description" [attr.id]="uniqueId + '-description'">
        {{ description() }}
    </span>
}

<label class="ap-checkbox" data-testid="label">
    <input
        class="ap-checkbox__input"
        data-testid="input"
        type="checkbox"
        [attr.aria-label]="label()"
        [attr.aria-describedby]="computedAriaDescribedby()"
        [attr.aria-invalid]="control ? control.invalid : null"
        [attr.disabled]="isDisabled ? isDisabled : null"
        [checked]="isChecked ? isChecked : null"
        (change)="onCheckboxChange($event)"
    />
    <span class="ap-checkbox__box">
        <ap-icon size="medium" name="checkbox-checked" class="ap-checkbox__icon--checked" data-testid="checked-icon"> </ap-icon>
        <ap-icon size="medium" name="checkbox-unchecked" class="ap-checkbox__icon--unchecked" data-testid="unchecked-icon"> </ap-icon>
    </span>

    @if (label()) {
        <span class="ap-checkbox__label-container">
            <span class="ap-checkbox__label" data-testid="label">{{ label() }}</span>
            @if (subtitle()) {
                <span class="ap-checkbox__label-sub" data-testid="sub-title" [innerHtml]="subtitle()"></span>
            }
        </span>
    }
    <ng-content select="[afterCheckbox]"></ng-content>
</label>

@if (control) {
    <ap-form-errors
        data-testid="errors"
        [control]="control"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}
